import { useEffect, useState } from 'react';

export type SavedSubmission = {
  marketingOptIn: boolean;
  ts: number;
};

/**
 * Reads a saved submission record from sessionStorage so a thank-you page can
 * reflect the real marketing preference after navigation. Returns ready=false
 * until the read has completed, and saved=null when no record exists (for
 * example a direct visit to the thank-you URL).
 */
export function useSavedSubmission(key: string): { saved: SavedSubmission | null; ready: boolean } {
  const [saved, setSaved] = useState<SavedSubmission | null>(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem(key);
      if (raw) {
        const parsed = JSON.parse(raw) as SavedSubmission;
        setSaved(parsed);
      } else {
        setSaved(null);
      }
    } catch {
      setSaved(null);
    }
    setReady(true);
  }, [key]);

  return { saved, ready };
}